import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useParams, Link } from 'react-router-dom';
import { MoonLoader } from 'react-spinners';



export default function PeopleDetails() {
    let {id} = useParams();
    const [peopleDetails, setPeopleDetails] = useState({});
    const [knownFor, setKnownFor] = useState(null);

    async function getPeopleDetails(){
        let {data} = await axios.get(`https://api.themoviedb.org/3/person/${id}?api_key=0ada3fcaa2e394ff1ad6ed7e6c5db6c5&language=en-US`);
        setPeopleDetails(data);
    }
    async function getWhatKnownFor(){
      let{data} = await axios.get(`https://api.themoviedb.org/3/person/${id}/combined_credits?api_key=0ada3fcaa2e394ff1ad6ed7e6c5db6c5&language=en-US`)
      setKnownFor(data.cast.filter(elem => elem.poster_path != null));
    }
    async function up(){
      window.scrollTo(0,0);
   } 
    useEffect(() => {
      getPeopleDetails();
      getWhatKnownFor();
      up()
    }, [])
    

  return <>
  { knownFor? <>
  
    <div className='container'>
    <div className="row">
        <div className="col-md-3 col-5  mt-4">
            <div>
                <img className='w-100 rounded-3' src={`https://image.tmdb.org/t/p/w500/${peopleDetails.profile_path}`} alt="" />
            </div>
        </div>
        <div className="col-md-9 col-7 p-3">
        <h2 className='my-3'>{peopleDetails.name}</h2>
        <h6>Biography</h6>
        <p className='text-muted'>{peopleDetails.biography}</p>
        <h5 className='mb-3'>Known for : {peopleDetails.known_for_department}</h5>
        <h5 className='mb-3'>Birthday : {peopleDetails.birthday}</h5>
        <h5 className='mb-3'>Place of Birth : {peopleDetails.place_of_birth}</h5>
        <h5 >Gender : {peopleDetails.gender == 2 ? "Male":"Female"}</h5>
        <h5>Appeared in:</h5>
          <div className="row">
            {knownFor.map((elem,idx) => elem.media_type == "movie" ? <div key={idx} className='col-md-2 col-4'>
              <Link to={`/moviedetails/${elem.id}`}>
              <figure>
              <img className='w-100 rounded-3' src={`https://image.tmdb.org/t/p/w500/${elem.poster_path}`} alt="" />
              </figure>
              </Link>
            </div>:<div key={idx} className='col-md-2 col-4'>
              <Link to={`/seriesdetails/${elem.id}`}>
              <figure>
              <img className='w-100 rounded-3' src={`https://image.tmdb.org/t/p/w500/${elem.poster_path}`} alt="" />
              </figure>
              </Link>
            </div>)}
          </div>
        </div>
    </div>
  </div>
  </>:<div className='vh-100 d-flex justify-content-center align-items-center'>
    <MoonLoader color="white"/>
    </div>}
</>
}
